import OnboardingConsent from "./OnboardingConsent";
import OnboardingSurvey from "./OnboardingSurvey";

const OnboardingQuestion = ({ cur_key, activityid, question, onChange, onComplete }) => {
  const datajson = question.datajson;
  const activity_type = datajson.type;

  const handleChange = (value) => {
    onChange(value);
    if (value === true || value === false) {
      onComplete(true);
    }
  };

  return (
    <div className="flex flex-col grow">
      <div className="flex flex-row grow sm:mx-12 sm:mt-12">
        <div className="w-full max-w-6xl mx-auto bg-background rounded-2xl flex flex-col justify-start p-8">
          {activity_type == "survey" && (
            <>
              <div className="text-md mb-6 text-left block" dangerouslySetInnerHTML={{ __html: datajson.html }} />
              <OnboardingSurvey
                activityid={activityid}
                datajson={datajson}
                onComplete={(allAnswered, answers, complete) =>
                  onComplete(allAnswered, answers, complete)
                }
              />
            </>
          )}
          {activity_type === "consent" && (
            <OnboardingConsent
              activityid={activityid}
              text_html={datajson.html}
              onChange={handleChange}
              onComplete={(consentGiven) => onComplete(consentGiven)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default OnboardingQuestion;
